import { z } from 'zod';

export const BordereauFailedPieceSchema = z.object({
  document_id: z.string().max(128),
  piece_number: z.string().max(128),
  error_code: z.string().max(128),
  phase: z.string().max(128),
});

export type BordereauFailedPiece = z.infer<typeof BordereauFailedPieceSchema>;

/**
 * API contract for polling a bordereau generation.
 *
 * `status` intentionally remains an open string because Redis/BullMQ can
 * expose provider-specific intermediate states; the terminal `errorCode` is
 * nevertheless shared so the frontend does not drift from the backend.
 */
export const BordereauGenerationStatusResponseSchema = z.object({
  status: z.string(),
  job_id: z.string().nullable().optional(),
  progress: z.number().min(0).max(100).optional(),
  download_url: z.string().optional(),
  file_ready: z.boolean().optional(),
  error: z.string().nullable().optional(),
  errorCode: z.string().nullable().optional(),
  failed_count: z.number().int().nonnegative().optional(),
  failed_pieces: z.array(BordereauFailedPieceSchema).optional(),
  available_formats: z.object({
    pdf: z.boolean(),
    pdf_with_cover: z.boolean(),
    zip: z.boolean(),
  }).optional(),
}).passthrough();

export type BordereauGenerationStatusResponse = z.infer<
  typeof BordereauGenerationStatusResponseSchema
>;
